import React from 'react';
import { isProductNew } from '../utils/productNews';

type RibbonSize = 'sm' | 'md' | 'lg';

const sizeClasses: Record<
  RibbonSize,
  { wrap: string; band: string; text: string }
> = {
  sm: {
    wrap: 'w-16 h-16',
    band: '-left-6 top-4 w-[5.5rem] py-0.5',
    text: 'text-[9px]',
  },
  md: {
    wrap: 'w-24 h-24',
    band: '-left-7 top-5 w-[7.5rem] py-1',
    text: 'text-xs',
  },
  lg: {
    wrap: 'w-28 h-28',
    band: '-left-8 top-6 w-[8.5rem] py-1.5',
    text: 'text-sm',
  },
};

interface ProductNewRibbonProps {
  newUntil?: string | null;
  /** Corner ribbon over image edge */
  size?: RibbonSize;
  className?: string;
}

const ProductNewRibbon: React.FC<ProductNewRibbonProps> = ({
  newUntil,
  size = 'md',
  className = '',
}) => {
  if (!isProductNew(newUntil)) return null;

  const s = sizeClasses[size];

  return (
    <div
      className={`pointer-events-none absolute left-0 top-0 z-20 overflow-hidden ${s.wrap} ${className}`}
      aria-hidden
    >
      <div
        className={`absolute ${s.band} ${s.text} font-extrabold uppercase tracking-wider text-center text-white bg-emerald-600 shadow-lg rotate-[-45deg] origin-center border border-emerald-400/90`}
      >
        NYHET
      </div>
    </div>
  );
};

export default ProductNewRibbon;
